var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.57922 1.83541L1.17113 10.8638C1.05963 11.0569 1.00063 11.2758 1.00001 11.4988C0.999381 11.7218 1.05715 11.941 1.16757 12.1347C1.27799 12.3285 1.43721 12.4899 1.62939 12.603C1.82156 12.7161 2.04 12.7768 2.26296 12.7793H13.0791C13.3021 12.7768 13.5205 12.7161 13.7127 12.603C13.9049 12.4899 14.0641 12.3285 14.1745 12.1347C14.285 11.941 14.3427 11.7218 14.3421 11.4988C14.3415 11.2758 14.2825 11.0569 14.171 10.8638L8.76289 1.83541C8.64906 1.64776 8.4888 1.49262 8.29755 1.38494C8.1063 1.27727 7.89053 1.2207 7.67105 1.2207C7.45158 1.2207 7.23581 1.27727 7.04456 1.38494C6.85331 1.49262 6.69305 1.64776 6.57922 1.83541V1.83541Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.67114 5.11719V7.67119",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.67114 10.2266H7.67848",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warningIcon.59eb5d36abf4962dd198985f12dede92.svg";
export { ForwardRef as ReactComponent };